import { DATA_STORE } from "./DataStore";
export default class Tags {
  constructor(asset_id) {
    const tags = DATA_STORE.getAssetTags(asset_id).filter((tag) => {
      const count = DATA_STORE.tagsScore[tag];
      return DATA_STORE.tagsScore[tag] != undefined && count > 4 && count < 100;
    });

    this.tags = [];
    this.domElement = document.createElement("div");
    this.domElement.classList.add("relatedTopics");

    this.headline = document.createElement("div");
    this.headline.classList.add("tags");
    this.headline.classList.add("tags-headline");
    this.headline.innerHTML = "RELATED TOPICS";
    this.domElement.appendChild(this.headline);

    this.tagsContainer = document.createElement("div");
    this.tagsContainer.classList.add("tags");
    this.domElement.appendChild(this.tagsContainer);

    // tags retrieved from the JSON
    this.tags = [];
    // console.log(tags);
    tags.forEach((tag, i) => {
      const link = document.createElement("button");

      const count = DATA_STORE.tagsScore[tag];
      link.textContent = tag + " (" + count + ")";
      link.classList.add("tag");

      link.style.opacity = 1;
      link.tag = tag;
      link.setAttribute("tag", tag);
      link.setAttribute("tabindex", 1);

      this.tagsContainer.appendChild(link);
      this.tags.push(link);
    });
  }
}
